// import Vue from 'vue'
// import Vuex from 'vuex'
// import getters from './getters'
// import app from './modules/app'


// Vue.use(Vuex)

// const store = new Vuex.Store({
//   modules: {
//     app
//   },
//   getters,
// })

// export default store



import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: ''
  },
  mutations: {
    set_token(state, token) {
      state.token = token
      sessionStorage.token = token // 会还存储
      localStorage.token = token//本地
    },
    del_token(state) {
      state.token = ''
      sessionStorage.removeItem('token')
      localStorage.removeItem('token')
    }
  }
}) 


// WEBPACK FOOTER //
// ./src/store/index.js